import { ActionTypes } from 'modules/iterableGoals/ducks/actionTypes';
import { PerformantCampaignData, PerformantCampaignQuery } from 'modules/iterableGoals/types';

export const fetchPerformantCampaignRequest = (queryData: PerformantCampaignQuery) => ({
  type: ActionTypes.FETCH_PERFORMANT_CAMPAIGNS_REQUEST,
  queryData,
});

export const fetchPerformantCampaignResponse = (data: PerformantCampaignData) => ({
  type: ActionTypes.FETCH_PERFORMANT_CAMPAIGNS_RESPONSE,
  payload: data,
});

export const fetchPerformantCampaignError = () => ({
  type: ActionTypes.FETCH_PERFORMANT_CAMPAIGNS_ERROR,
});
